import * as Sentry from "@sentry/capacitor";
import * as SentryReact from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { InstallPrompt } from "@/components/InstallPrompt";
import { sentryEnvironment } from "@/lib/sentry";

Sentry.init(
  {
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: sentryEnvironment(),
    enabled: import.meta.env.PROD,
    tracesSampleRate: 0.1,
    integrations: [
      SentryReact.browserTracingIntegration(),
      // Décision D6 (docs/plans/2026-10-14-conformite-00-index.md) : le replay ne doit
      // jamais montrer en clair noms, messages ou données saisies, et ne s'enregistre
      // qu'en cas d'erreur — un enregistrement d'écran systématique n'est pas nécessaire
      // au service et demanderait un consentement.
      SentryReact.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  },
  SentryReact.init
);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
    <InstallPrompt />
  </StrictMode>
);
